import { createSlice } from "@reduxjs/toolkit";
import { DetalheConfiguracaoImportacaoVendaModel } from "../../../models/detalheConfiguracaoImportacaoVenda/detalheConfiguracaoImportacaoVendaModel";
import { listarDetalheConfiguracaoImportacaoVenda } from "../../../services/detalheConfiguracaoImportacaoVendaService";

export interface DetalheConfiguracaoImportacaoVendaState {
  //buscar detalhe configuracao importacao venda
  loading: boolean;
  busca: number;
  list: DetalheConfiguracaoImportacaoVendaModel[];
  entity: DetalheConfiguracaoImportacaoVendaModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: DetalheConfiguracaoImportacaoVendaState = {
  //buscar detalhe configuracao importacao venda
  loading: false,
  busca: 0,
  list: [],
  entity: {} as DetalheConfiguracaoImportacaoVendaModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const detalheConfiguracaoImportacaoVendaSlice = createSlice({
  name: "detalheConfiguracaoImportacaoVenda",
  initialState,
  reducers: {
    //buscar detalhe configuracao importacao venda
    setBuscaDetalheConfiguracaoImportacaoVenda: (state, action) => {
      state.busca = action.payload;
    },
    setEntityDetalheConfiguracaoImportacaoVenda: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarDetalheConfiguracaoImportacaoVenda: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarDetalheConfiguracaoImportacaoVenda: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //buscar detalhe configuracao importacao venda
    builder.addCase(listarDetalheConfiguracaoImportacaoVenda.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarDetalheConfiguracaoImportacaoVenda.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(listarDetalheConfiguracaoImportacaoVenda.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar detalhe configuracao importacao venda
  setBuscaDetalheConfiguracaoImportacaoVenda,
  setEntityDetalheConfiguracaoImportacaoVenda,
  //internal
  setModalCadastrarDetalheConfiguracaoImportacaoVenda,
  setModalDeletarDetalheConfiguracaoImportacaoVenda,
} = detalheConfiguracaoImportacaoVendaSlice.actions;

export default detalheConfiguracaoImportacaoVendaSlice.reducer;
